import { useParams } from 'react-router';

import { SaveStationButton } from '@/features/favorites-toggle';
import {
	NavigationButtonGroup,
	PriceInfo,
	StationInfo,
	useStationPageData,
} from '@/features/station';

const StationInfoContent = () => {
	const { stationId } = useParams();
	const {
		gasStation,
		distance,
		regionPrice,
		gasolinePrice,
		dieselPrice,
		gasolineAverage,
		dieselAverage,
		launchNavigationApp,
	} = useStationPageData(stationId);

	return (
		<div className="flex min-h-92 flex-col items-center p-5">
			<StationInfo
				stationName={gasStation?.OS_NM}
				address={gasStation?.NEW_ADR}
				phone={gasStation?.TEL}
				distance={distance}
				actionSlot={
					gasStation?.UNI_ID ? (
						<SaveStationButton stationId={gasStation.UNI_ID} />
					) : undefined
				}
			/>
			<section className="flex self-stretch px-1 py-2">
				<PriceInfo
					fuelType="휘발유"
					currentPrice={gasolinePrice}
					averagePrice={gasolineAverage}
					region={regionPrice?.sido}
				/>
				<PriceInfo
					fuelType="경유"
					currentPrice={dieselPrice}
					averagePrice={dieselAverage}
					region={regionPrice?.sido}
				/>
			</section>
			<p className="py-2 font-light text-[10px] text-mantang-gray-500">
				2026.04.06 17시에 업데이트된 가격이에요
			</p>
			<div className="mt-2 self-stretch">
				<NavigationButtonGroup onNavigate={launchNavigationApp} />
			</div>
		</div>
	);
};

export default StationInfoContent;
